import React, { useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { FcGoogle } from "react-icons/fc";

export default function Login() {
  const { token } = useAuth();
  const navigate = useNavigate();

  // Redirect if already logged in, and set page title
 useEffect(() => {
    if (token) navigate("/dashboard", { replace: true });

    // Set page title
    document.title = "Sign up • Backlink Banana";

    // Set (or update) description meta tag
    const description =
      "Sign up with Google to start using Backlink Banana. Instantly discover backlinks, SEO metrics, and LinkedIn prospects — save hours of manual research.";
    let metaDesc = document.querySelector("meta[name='description']");
    if (!metaDesc) {
      metaDesc = document.createElement("meta");
      metaDesc.setAttribute("name", "description");
      document.head.appendChild(metaDesc);
    }
    metaDesc.setAttribute("content", description);
  }, [token, navigate]);
  

  const GOOGLE_LOGIN_URL = `${process.env.REACT_APP_BACKEND_URL}/auth/login`;

  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-b from-indigo-100 to-white px-4">
      <div className="bg-white rounded-2xl shadow-xl p-10 max-w-md w-full border border-gray-100">
        {/* Headline */}
        <h1 className="text-3xl font-extrabold text-blue-900 text-center mb-3">
          Join Backlink Banana
        </h1>
        <p className="text-center text-gray-600 mb-8">
          Discover backlinks, connect with decision-makers, and save hours of manual research.
        </p>

        {/* Google Sign-In */}
        <a href={GOOGLE_LOGIN_URL} className="block">
          <button
            type="button"
            aria-label="Continue with Google"
            className="w-full flex items-center justify-center gap-3 border border-gray-300 text-gray-900 font-medium rounded-lg px-5 py-3 text-lg hover:bg-gray-50 hover:shadow-md active:scale-[0.98] transition"
          >
            <FcGoogle size={26} />
            Continue with Google
          </button>
        </a>

        {/* Legal Links */}
        <p className="mt-8 text-center text-xs text-gray-500 leading-relaxed">
          By signing up, you agree to our{" "}
          <Link
            to="/terms-and-conditions"
            className="text-blue-600 underline hover:text-blue-800"
          >
            Terms of Service
          </Link>{" "}
          and{" "}
          <Link
            to="/privacy-policy"
            className="text-blue-600 underline hover:text-blue-800"
          >
            Privacy Policy
          </Link>
          .
        </p>
      </div>
    </div>
  );
}
